export default "__VITE_PUBLIC_ASSET__09c34a46__"